import { SortDirection } from '@angular/material/sort';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { PAGE_SIZE_DEFAULT } from '../../_common/constants';
import { PrinterListResponse, PrinterModel, PrinterTypeListResponse } from './printer.model';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { PrinterHistoryListResponse } from './printer-history-dialog/printer-history.model';
import { BrandService } from '../brands/brand.service';

@Injectable({
  providedIn: 'root'
})

export class PrinterService {
  constructor(private http: HttpClient,
    private toastr: ToastrService,
    private brandService: BrandService,
    @Inject('API_URL') private apiUrl: string
  ) { }

  private printerComponentMethodCaller = new Subject<any>();
  componentMethodCalled$ = this.printerComponentMethodCaller.asObservable();

  callAddOrEditPrinterOpenDialog() {
    this.printerComponentMethodCaller.next();
  }

  getPrinters(pageIndex: number = 0, pageSize: number = PAGE_SIZE_DEFAULT, sortBy: string, sortDir: SortDirection, filter: any): Observable<PrinterListResponse> {
    return this.http
      .get<PrinterListResponse>(
        this.apiUrl + 'printer/printers',
        {
          params: new HttpParams()
            .set('sortBy', sortBy)
            .set('sortDir', sortDir)
            .set('pageNumber', pageIndex.toString())
            .set('pageSize', pageSize.toString())
            .set('filter', JSON.stringify(filter))
        }
      );
  }

  savePrinter(printerModel: PrinterModel): Observable<PrinterModel> {
    return this.http
      .post<any>(this.apiUrl + 'printer/save', printerModel)
      .pipe(map(response => {
        if (response.error.message) {
          this.toastr.error(response.error.message);
        }
        this.brandService.getBrandList();
        return response.model;
      })
    );
  }

  getPrinterHistory(id: number): Observable<PrinterHistoryListResponse> {
    return this.http.get<PrinterHistoryListResponse>(this.apiUrl + 'printer/history/' + id);      
  }

  getPrinterTypeList(): Observable<PrinterTypeListResponse> {
    return this.http.get<PrinterTypeListResponse>(this.apiUrl + 'printer/printer-type-list');      
  }
}
